<template>
  <AppShell debug-title="/customers/me" :debug-data="debugData">
    <section class="mx-auto max-w-2xl space-y-8">
      <div class="flex size-12 items-center justify-center border border-destructive/30 bg-destructive/10 text-destructive">
        <AlertCircle class="size-5" />
      </div>

      <div class="space-y-3">
        <p class="app-eyebrow">{{ t("externalIdNotFound.eyebrow") }}</p>
        <h1 class="text-3xl font-bold tracking-tight md:text-4xl">
          {{ t("externalIdNotFound.title") }}
        </h1>
        <p class="text-sm leading-7 text-brand-muted-strong">
          {{ t("externalIdNotFound.description") }}
        </p>
      </div>
    </section>
  </AppShell>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { AlertCircle } from "lucide-vue-next";
import AppShell from "@/components/AppShell.vue";
import { useAuth } from "@/lib/auth";
import { useCustomerSession } from "@/features/customer-session";
import { getDebugEnv } from "@/lib/debug-env";
import { useI18n } from "@/lib/i18n";

const auth = useAuth();
const customerSession = useCustomerSession();
const { t } = useI18n();

const debugData = computed(() => ({
  user: auth.state.user,
  customer: customerSession.current,
  env: getDebugEnv(),
  error: "External ID not found",
}));
</script>
